import logo from './logo.svg';

import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import React, { useState, useLayoutEffect } from 'react';
import { BrowserRouter, NavLink, Routes, Route, Navigate, useLocation} from 'react-router-dom';
import { AuthProvider } from './Authentication/AuthProvider';

import Header from './component_home/Header';
import Footer from './component_home/Footer';

function App() {


  const Wrapper = ({children}) => {
    const location = useLocation();
    useLayoutEffect(() => {
      document.documentElement.scrollTo(0, 0);
    }, [location.pathname]);
    return children
  } 


  return (
    
    <div className="app-wrapper">
      <AuthProvider>
        <BrowserRouter>
          <Wrapper>

          <main className="app-content">
            <Header/>
          </main>
            <Footer/>

          </Wrapper>
        </BrowserRouter>
      </AuthProvider>
    </div>

  );
}

export default App;
